module.exports = __webpack_public_path__ + "img/profile_sp.ed2310e1.jpg";